const getPreferenceCenterOptionsFromBrowserUrl = require("./getPreferenceCenterOptionsFromBrowserUrl");
const setPreferenceCenterOptions = require("./setPreferenceCenterOptions");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function setPreferenceCenterOptionsFromBrowserUrl(preferenceCenter) {
    const options = getPreferenceCenterOptionsFromBrowserUrl();
    setPreferenceCenterOptions(preferenceCenter, options);
}
